import {FLIP_CARD_SIDE} from '../../incase-domain/elements/flipCard';
import {FLIP_CARD, FlipCardReducerType} from '../actions/types/flipCard.types';

export interface FlipCardState {
    [elementId: string]: FLIP_CARD_SIDE;
}

export const flipCardInitialState: FlipCardState = {};

export const flipCardReducer = (state: FlipCardState = flipCardInitialState, action: FlipCardReducerType): FlipCardState => {
    switch (action.type) {
        case FLIP_CARD: {
            const {elementId, flipCardSide} = action.payload;
            return {
                ...state,
                [elementId]: flipCardSide,
            };
        }
        default:
            return state;
    }
};
